import { IScope, IRootScopeService, IPromise } from "angular";
import { StateService } from "@uirouter/angularjs";
import { HierarchyNode } from "d3-hierarchy";
import { IPlanningSession } from "../models/models";
import { IStateInit } from "@gtmhub/core/routing";
import { INgRedux } from "@gtmhub/state-management";
import { PlanningSessionsActions } from "../redux/session-actions";
import { ISessionsStoreState } from "../redux/session-reducer";

interface ISessionSelectorStateParamsService {
  id: string;
}

export interface ISessionSelectorScope extends IScope {
  sessions: HierarchyNode<IPlanningSession>[];
  params: ISessionSelectorStateParamsService;
  select(session: HierarchyNode<IPlanningSession>): void;
}

export class SessionSelectorCtrl implements IStateInit {
  public static $inject = ["$rootScope", "$scope", "PlanningSessionsActions", "$state", "$stateParams", "$ngRedux"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: ISessionSelectorScope,
    private planningSessionsActions: PlanningSessionsActions,
    private $state: StateService,
    private $stateParams: ISessionSelectorStateParamsService,
    private $ngRedux: INgRedux
  ) {
    this.$scope.select = this.select;
    this.$scope.params = { ...this.$stateParams };

    const unsubscribe = this.$ngRedux.connect(this.bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);
  }

  public stateInit(): IPromise<unknown> {
    return this.$ngRedux.dispatch(this.planningSessionsActions.getSessionsIfMissing());
  }

  private bindStateToScope = (state: ISessionsStoreState): Record<string, unknown> => {
    return {
      sessions: state.sessions.tree ? state.sessions.tree.children : [],
    };
  };

  private select = (session: HierarchyNode<IPlanningSession>): void => {
    if (session.id !== this.$scope.params.id && session.data.status !== "closed") {
      this.$rootScope.$broadcast("sessionSelected", session.id);
      this.$state.go("^.^");
    }
  };
}
